import React from 'react';

function Loading() {
	return (
		<div className="loader">
			<div className="gooey">
				<span className="dot"></span>
				<div className="dots">
					<span></span>
					<span></span>
					<span></span>
				</div>
			</div>
		</div>
	);
}

export default Loading;
